export { default as translations } from './translations.json';

export const MAX_PINNED_MESSAGES = 5;

/**
 * Get pinned messages from transaction.
 * @param {Object|null} transaction
 * @returns {Object[]}
 */
export const getPinnedMessages = (transaction) =>
  transaction?.attributes?.metadata?.pinnedMessages || [];

export const hasPinnedMessages = (transaction) =>
  getPinnedMessages(transaction).length > 0;

/**
 * Check if a specific message is pinned.
 * @param {Object|null} transaction
 * @param {string} messageId
 * @returns {boolean}
 */
export const isMessagePinned = (transaction, messageId) =>
  getPinnedMessages(transaction).some(m => m.messageId === messageId);

export const canPinMore = (transaction) =>
  getPinnedMessages(transaction).length < MAX_PINNED_MESSAGES;
